import React, { useState, useEffect } from 'react';
import Pagination from 'react-paginate';
import TitleNames from '../../Component/Header/TitleNames'
import './Allquerydashboard.css'
import { data } from '../../Component/data'

import { Link, useNavigate, useParams } from "react-router-dom";
import { PostAPI, GetAPI } from '../../common/Api';
import moment from 'moment';
const Allquerydashboard = () => {


  const navigate = useNavigate();
  const { alquerydashboard } = useParams()
  const [queryTable, setQueryTable] = useState([])

  const personalquerydashboard = JSON.parse(sessionStorage.getItem('login_details')).counsellor_id;

  const [Alviewdashboard, setAlviewdashboard] = useState([])
  const [alviewHeaddashboard, setalviewHeaddashboard] = useState([])
  useEffect(() => {
    let formData = new FormData();
    formData.append('counsellor_id', personalquerydashboard);
    formData.append('user_id', alquerydashboard);
    
    var apiData = {
      url: 'get_user_aldetails',
      data: formData
    }

    PostAPI(apiData, (res) => {
      if (res && res.status) {
        setAlviewdashboard(res?.data)
        setalviewHeaddashboard(res?.user_data)
        console.log("hg", res?.data)
      }
    })
  }, [])

  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 5;

  const handlePageClick = () => {
    // console.log(queryTable)
    setCurrentPage(queryTable?.selected);
  };

  const indexOfLastItem = (currentPage + 1) * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = queryTable.slice(indexOfFirstItem, indexOfLastItem);
  console.log('data', data)
  console.log('currentData', currentData)
  console.log(indexOfFirstItem, indexOfLastItem)
  return (
    <>
      <div><TitleNames /></div>
      <div className="container-fluid"> <div className='AllQueryDetailsmain'>

        <form action=""> <div class="form-row">
          <div className="form-group col-lg-6 col-md-12 AllQueryPersonNameNumber">
            <div className='QueryDetailsContent'><p className='UserNameQuery'>User NAME </p>
              <span className='Dotspace'>:</span>
              <p className='NameQuery'>{alviewHeaddashboard[0]?.user_name}</p></div>

            <div className='QueryDetailsContent'><p className='UserNameQuery'>User Numbe </p>
              <span className='Dotspace'>:</span>
              <p className='NameQuery'>{alviewHeaddashboard[0]?.user_phone}</p>
            </div>
          </div>
          <div class="form-group col-lg-6 col-md-12">

          </div>
        </div>
        </form>


        {/* <div className='AllqueryPersonDetails'>
          <div><p className='List_Query'>All Query List</p></div>
          <div>
            <ul class="nav nav-pills navBar ">
              {personallquery.map((item) => {
                return (<li className="nav-item navBar-list">
                  <button className='btn btn-secondary'>
                    <a className="nav-link" >{item.name}</a>
                  </button>
                </li>)
              })}

            </ul>
          </div>
        </div> */}

        <div class="row table-responsive container-fluid">
          <div className='card-box'>

            <table class="table card-body Bor_Table">

              {/* <caption>List of users</caption> */}
              <thead>
                <tr className='DetailsHeadings'>
                  <th className='MainTitiles-new' scope="col">S.No</th>

                  <th className='MainTitiles-new' scope="col">Date & Time</th>
                  <th className='MainTitiles-new' scope="col">User Mode</th>
                  <th className='MainTitiles-new' scope="col">What are you looking for?</th>
                  <th className='MainTitiles-new' scope="col">Category 1</th>
                  <th className='MainTitiles-new' scope="col">Category 2</th>
                  <th className='MainTitiles-new' scope="col">Query</th>
                  <th className='MainTitiles-new' scope="col">Status</th>
                  <th className='MainTitiles-new' scope="col">Action</th>
                </tr>
              </thead>

              {Alviewdashboard.map((data, index) => (
                <tbody>


                  <tr className='AllContentDetails'>
                    <td className='MainTitiles-new'><Link to="/querydetails" className='DetalsList'>{index + 1} </Link></td>

                    <td className='MainTitiles-new'><p  className='DetalsList'>{moment(data?.query_sent_on).format("DD MMM YYYY HH:mm A") }</p></td>
                    <td className='MainTitiles-new'><p  className='DetalsList'>{data.user_mode}</p></td>
                    <td className='MainTitiles-new'><Link to="/querydetails" className='DetalsList'>{data.looking_for}</Link></td>
                    <td className='MainTitiles-new'><p  className='DetalsList'>{data.choice_one}</p></td>
                  <td className='MainTitiles-new'><p  className='DetalsList'>{data.choice_two}</p></td>
                  <td className='QueryDetails MainTitiles-new'><p  className='DetalsList'>{data.query}</p></td>
                    <td className='MainTitiles-new'><Link to="/querydetails" className='DetalsList'>{data.status}</Link></td>
                    <td className='MainTitiles-new'><Link to={`/querydetails/${data?.id}`} className='DetalsList' onClick={()=>console.log("dfgh",data)}>
                    <p>View | Update status</p>
                    
                    </Link></td>
                  </tr>
                </tbody>))}



            </table>

            <div className='PagiDetsils'>
            <p className='C0untDaetils'>Showing {indexOfFirstItem + 1} to {(queryTable?.length - indexOfLastItem) > 0 ? indexOfLastItem : queryTable?.length} of {queryTable?.length} entries</p>
            <Pagination
              pageCount={Math.ceil(queryTable?.length / itemsPerPage)}
              onPageChange={handlePageClick}
              containerClassName={"pagination FullPaginatecss"}
              activeClassName={"active"}

            />
          </div>
          </div>
        </div>

      </div>
      </div>


    </>
  )
}

export default Allquerydashboard